export class QuantitativosDashboard {
	quantidadeEditaisPublicados?: string;
	quantidadeOrgaos?: string;
	quantidadeUorgs?: string;
	quantidadeOportunidadesPublicadas?: string;
	quantidadeCandidatosInscritos?: string;
}
